import { create } from 'zustand';

export interface Hint {
  id: string;
  text: string;
  priority: 'low' | 'medium' | 'high';
}

interface HintState {
  currentHint: Hint | null;
  dismissedHints: Set<string>;
  lastShownAt: number; // timestamp
  showHint: (hint: Hint) => void;
  dismissHint: (id: string) => void;
  clearHint: () => void;
}

export const useHintStore = create<HintState>((set) => ({
  currentHint: null,
  dismissedHints: new Set(),
  lastShownAt: 0,

  showHint: (hint) =>
    set((state) => {
      // Don't show if already dismissed
      if (state.dismissedHints.has(hint.id)) return state;
      // Don't override a higher priority hint
      if (state.currentHint && state.currentHint.priority === 'high' && hint.priority !== 'high') {
        return state;
      }
      return {
        currentHint: hint,
        lastShownAt: Date.now(),
      };
    }),

  dismissHint: (id) =>
    set((state) => {
      const newDismissed = new Set(state.dismissedHints);
      newDismissed.add(id);
      return {
        dismissedHints: newDismissed,
        currentHint: state.currentHint?.id === id ? null : state.currentHint,
      };
    }),

  clearHint: () => set({ currentHint: null }),
}));
